import { useMemo } from 'react'
import { currencyMap } from 'utils/formatMoney'
import { IS_APP_PRODUCT_GETUNIQ } from 'utils/constants/product'

const useChartMeasures = (networkType) =>
  useMemo(() => {
    switch (networkType) {
      case 'vkads':
        return {
          measure: {
            clicks: '',
            impressions: '',
            spent: IS_APP_PRODUCT_GETUNIQ ? currencyMap.rub : '',
          },
          metrics: [
            { id: 'clicks', isActive: true },
            { id: 'impressions', isActive: true },
            { id: 'spent', isActive: true },
          ],
        }
      default:
        return {
          measure: {
            impressions: '',
            clicks: '',
            revenue: IS_APP_PRODUCT_GETUNIQ ? currencyMap.rub : '',
            cost: IS_APP_PRODUCT_GETUNIQ ? currencyMap.rub : '',
          },
          metrics: [
            { id: 'clicks', isActive: true },
            { id: 'impressions', isActive: true },
            { id: 'cost', isActive: true },
            { id: 'revenue', isActive: true, isHidden: true },
          ],
        }
    }
  }, [networkType])

export default useChartMeasures
